module.exports = __webpack_public_path__ + "static/media/link.d872c9e3.svg";